export function getQueryParams(queryString) {
    var items = queryString.substring(1).split('&');
    var queryParams = {};
    items.forEach(function (item) {
        var _a = item.split('='), key = _a[0], value = _a[1];
        queryParams[key] = value;
    });
    return queryParams;
}
